'use client';

import {IMGPW} from '@/config';
import {useTranslations} from 'next-intl';
import {FC, useState} from 'react';
import BusinessForm from '../../../../../components/google-forms/BusinessForm';
import BarOfCompanies from '../../components/BarOfCompanies';
import BusinessCard from '../../components/BusinessCard';
import BusinessHeader from '../../components/BusinessHeader';
import CardsContainer from '../../components/CardsContainer';
import SuggestedProducts from '@/app/[locale]/business/components/SuggestedProducts';
import Image from 'next/image';
import BarOfBrands from '@/app/[locale]/business/components/BarOfBrands';
import {Modal} from '@/components/design-system';

const CompanyGift: FC = () => {
  const t = useTranslations('business');
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [formType, setFormType] = useState<string>('regalistica-aziendale');

  const onFormSent = () => {
    setIsModalOpen(true);
  };

  const showForm = (form: string) => {
    setFormType(form);
    const element = document.getElementById('form');
    if (!element) {
      return;
    }
    window.scrollTo({
      behavior: 'smooth',
      top: element.offsetTop,
    });
  };

  return (
    <div>
      <div className="section-container mt-4">
        <Image
          height={100}
          width={178}
          src={IMGPW + '/WL_for_business.png'}
          alt="Winelivery For Business"
        />
      </div>
      <BusinessHeader
        title={t('CorporateGifting.Header.Title')}
        subtitle={t('CorporateGifting.Header.Subtitle')}
        paragraph={t('CorporateGifting.Header.Paragraph')}
        imgSrc={`${IMGPW}/business/regalistica-aziendale.jpg`}
        cta={{
          title: t('CorporateGifting.Header.CTA'),
          url: `#form`,
          target: '_self',
        }}
      />

      <BarOfCompanies />

      <CardsContainer>
        <BusinessCard
          imageUrl={`${IMGPW}/business/regalistica-natalizia.jpg`}
          title={t('CorporateGifting.Categories.card-1.title-heading')}
          paragraph={t('CorporateGifting.Categories.card-1.paragraph')}
          cta={t('CorporateGifting.Categories.card-1.cta')}
          url={'regalistica-aziendale'}
          buttonId="regalistica-aziendale-richiedi-informazioni"
          onPress={showForm}
          imageMaxHeight={300}
        />
        <BusinessCard
          imageUrl={`${IMGPW}/business/voucher.jpg`}
          title={t('CorporateGifting.Categories.card-2.title-heading')}
          paragraph={t('CorporateGifting.Categories.card-2.paragraph')}
          cta={t('CorporateGifting.Categories.card-2.cta')}
          url={'voucher-regalo'}
          buttonId="regalistica-aziendale-richiedi-informazioni"
          onPress={showForm}
          imageMaxHeight={300}
        />
      </CardsContainer>

      <div className="bg-greyscale-gray-lighter">
        <SuggestedProducts />
      </div>

      {formType && (
        <div className="section-container mt-12" id="form">
          <BusinessForm
            formType={formType}
            section="gift"
            buttonId="regalistica-aziendale-lead-form"
            onSent={onFormSent}
            formSubtitle={t('CorporateGifting.Header.form-subtitle')}
          />
        </div>
      )}

      <BarOfBrands />

      <Modal
        whiteHeader
        size="md"
        onClose={() => {
          setIsModalOpen(false);
        }}
        isOpen={isModalOpen}
      >
        <div className="px-5 text-center">
          <div className="text-center border-greyscale-gray-light">
            <Image
              className="py-4 mx-auto object-contain"
              src={
                'https://upload.wikimedia.org/wikipedia/commons/5/51/Green-checkmark.svg'
              }
              width={120}
              height={120}
              alt="Done!"
            />
            <h3 className="font-bold">{t('SuccessModal.Title')}</h3>
          </div>
          <h6 className="text-balance">{t('SuccessModal.Subtitle')}</h6>
          <div>
            <a
              className="mt-2 button btn-primary btn-md leading-10"
              href={`${IMGPW}/business/catalogo_regalistica_2026.pdf`}
              rel="nofollow"
              target="_blank"
              id="regalistica-aziendale-scarica-catalogo"
            >
              {t('CorporateGifting.Header.download-btn')}
            </a>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default CompanyGift;
